/* eslint-disable */
import convertList from '../convertList';
import filters from '../filters';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'
import errorAction from '@/components/contact-selector/enum/errorAction'
// 加载临界值，小于该数字直接加载详情
const LOAD_DETAIL_NUM = 100;

export default function(config) {
    const moreConfig = {
        totalState: false
    };
    const selfConfig = config.extendConfig && config.extendConfig[config.base.field] || {};
    const datasource = [];
    // if (config.base.config.loadByPaginate) {
        return new Promise((resolve, reject) => {
            _getCompanyWeChatOrg()
                .then(res => {
                    let {data, code, message} = res
                    let list = [];
                    if(code !== 0){
                        reject({
                            action: errorAction.ShowErrorInNoData,
                            msg: message
                        })
                        return
                    }
                    let {users, deps} = data
                    list = deps.map(x => {
                        const obj = x;
                        return {
                            id: x.id,
                            name: x.name,
                            list:[],
                            // type: "group",
                            loaded: false
                        }
                    });
                    list = [...list, ...users.map(x => {
                        const obj = x;
                        obj.face = x.avatar
                        obj.id = x.userid
                        return obj
                    })];


                    config = Object.assign(config, moreConfig);
                    const newList = convertList(list, {
                        list: 'list',
                        groupName: 'name'
                    }, config);

                    resolve(newList);
                })
                .catch(err => {
                    reject(err);
                });
        });

}


function _getCompanyWeChatOrg() {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/wework/DepTreeNode`);
}


